// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/runway-markings.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/runway-markings/runway-markings.js';
import g1 from '../lessons/aeronautics/runway-markings/taxiway-markings.js';

mount([g0, g1]);
